import './vendor';
import lazyLoading from './modules/lazyLoading';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')
require('../../node_modules/@cmyee/pushy/js/pushy')
lazyLoading.init();

$('.certs-slider').slick({
	dots: false,
	speed: 1000,
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 1,
	prevArrow: '<button type="button" class="btn-slider prev"><svg width="23" height="14" viewBox="0 0 23 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.94098 5.66913L22.8105 5.66913L22.8105 7.66913L3.94098 7.66913L8.65279 12.3809L7.23858 13.7952L0.11255 6.66913L6.39398 0.387695L7.8082 1.80191L3.94098 5.66913Z" fill="currentColor"/></svg></button>',
	nextArrow: '<button type="button" class="btn-slider next"><svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.059 8.33087L0.189453 8.33087L0.189453 6.33087L19.059 6.33087L14.3472 1.61906L15.7614 0.204849L22.8874 7.33087L16.606 13.6123L15.1918 12.1981L19.059 8.33087Z" fill="currentColor"/></svg></button>',
	responsive: [
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				vertical: false,
		    }
		}
	]
});



$('.clients-slider ').slick({
	dots: false,
	speed: 1000,
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 1,
	prevArrow: '<button type="button" class="btn-slider prev"><svg width="23" height="14" viewBox="0 0 23 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.94098 5.66913L22.8105 5.66913L22.8105 7.66913L3.94098 7.66913L8.65279 12.3809L7.23858 13.7952L0.11255 6.66913L6.39398 0.387695L7.8082 1.80191L3.94098 5.66913Z" fill="currentColor"/></svg></button>',
	nextArrow: '<button type="button" class="btn-slider next"><svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.059 8.33087L0.189453 8.33087L0.189453 6.33087L19.059 6.33087L14.3472 1.61906L15.7614 0.204849L22.8874 7.33087L16.606 13.6123L15.1918 12.1981L19.059 8.33087Z" fill="currentColor"/></svg></button>',
	responsive: [
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				vertical: false,
		    }
		}
	]
});


$(".scroll").on("click", function (event) {
    // исключаем стандартную реакцию браузера
    event.preventDefault();

    // получем идентификатор блока из атрибута href
    var id  = $(this).attr('data-scroll-to'),

    // находим высоту, на которой расположен блок
        top = $(id).offset().top;

    // анимируем переход к блоку, время: 800 мс
    $('body,html').animate({scrollTop: top}, 800);
});

if(document.querySelector(".popup")) {
	$('.popup').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		closeBtnInside: false,
		fixedContentPos: true,
		mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
		image: {
			verticalFit: true
		},
		zoom: {
			enabled: true,
			duration: 300 // don't foget to change the duration also in CSS
		}
	});
}


document.addEventListener('DOMContentLoaded', function () {
	// Выбираем все элементы с классом .advant
	var advantItems = document.querySelectorAll('.advantages__item.advant');
    
	// Перебираем каждый элемент .advant
	advantItems.forEach(function (item, index) {
	    // Создаем элемент .advant__lines
	    var linesContainer = document.createElement('div');
	    linesContainer.classList.add('advant__lines');
    
	    // Добавляем соответствующее количество тегов <span>
	    for (var i = 0; i <= index; i++) {
		var span = document.createElement('span');
		linesContainer.appendChild(span);
	    }
    
	    // Находим элемент .advant__wrap внутри текущего .advant
	    var wrap = item.querySelector('.advant__wrap');
    
	    // Вставляем .advant__lines перед .advant__wrap
	    item.insertBefore(linesContainer, wrap);
	});
    });